import React, { createContext, useContext } from 'react';
import { Storage } from '@24i/nxg-sdk-quantum';
import {
    ASYNC_STORAGE_KEY_USER_TOKEN,
    ASYNC_STORAGE_KEY_USER,
    ASYNC_STORAGE_KEY_USER_PSEUDO_ID,
} from '@24i/nxg-core-utils/src/constants';
import { v1 as uuid } from 'uuid';

import { UserDataClient } from '@24i/nxg-sdk-photon';
import { getDefaultUserDataClient } from './defaultClient';

const dummyDataClient = getDefaultUserDataClient();

export const UserDataContext = createContext<UserDataClient>(dummyDataClient);

export const UserDataProvider = ({ client = dummyDataClient, children }) => {
    return <UserDataContext.Provider value={client}>{children}</UserDataContext.Provider>;
};

export const useUserData = () => useContext(UserDataContext);

export const setUserToken = async (token: string) =>
    Storage.setItem(ASYNC_STORAGE_KEY_USER_TOKEN, token);

export const setUserDataToStorage = async (data) =>
    Storage.setItem(ASYNC_STORAGE_KEY_USER, JSON.stringify(data));

export const getPseudoId = async (): Promise<string> => {
    let pseudoId = await Storage.getItem(ASYNC_STORAGE_KEY_USER_PSEUDO_ID);
    if (!pseudoId) {
        pseudoId = uuid();
        await Storage.setItem(ASYNC_STORAGE_KEY_USER_PSEUDO_ID, pseudoId);
    }
    return pseudoId;
};

export const resetUserPseudoId = async (): Promise<string> => {
    const pseudoId = uuid();
    await Storage.setItem(ASYNC_STORAGE_KEY_USER_PSEUDO_ID, pseudoId);
    return pseudoId;
};
